<template>
  <div :class="'na-aside-map' + (show ? ' show' : '')">
    <div class="na-aside-content">
      <!-- GREEN HEADER -->
      <div class="na-aside-header">
        <div>
          <h5 class="na-aside-title">{{ title[0] || '' }}</h5>
          <h6 class="na-aside-subtitle" v-if="title.length > 1">{{ title[1] }}</h6>
        </div>
        <button type="button" class="btn na-aside-close" @click="close">
          <font-awesome-icon icon="fa fa-x" />
        </button>
      </div>

      <!-- SCROLLABLE BODY -->
      <div class="na-aside-body">
        <slot name="body"></slot>
      </div>

      <!-- FOOTER -->
      <div class="na-aside-footer" v-if="$slots.footer">
        <slot name="footer"></slot>
      </div>
    </div>
    <div v-html="dynamicCss()"></div>
  </div>
</template>

<script>
export default {
  name: "NewAside",
  data() {
    return {
      title: ["-"],
      show: false,
      footerButton: null, // compatibility with old Aside
    };
  },
  watch: {
    show(s) {
      this.$emit("show", s);
    },
  },
  methods: {
    fadeIn(title) {
      this.title = title;
      if (this.show) {
        this.show = false;
        setTimeout(() => {
          this.show = true;
        }, 10);
      } else {
        this.show = true;
      }
    },
    close() {
      this.show = false;
      this.$emit("close");
    },
    dynamicCss() {
      var z1 = !this.show ? 1100 : 900;
      var z2 = this.show ? 1000 : 900;
      return `<style>
        .leaflet-top.leaflet-right { z-index: 2000; }
        .map-body { z-index: 1100; }
        @media (max-width: 700px) {
          .leaflet-top.leaflet-right { z-index: ${z1} !important; }
          .map-body { z-index: ${z2}; }
        }
      </style>`;
    },
  },
};
</script>

<style>
.na-aside-map {
  height: 100%;
  width: 380px;
  position: fixed;
  z-index: 1200;
  right: 0;
  top: 0;
  transform: translateX(100%);
  overflow: hidden;
  pointer-events: auto;
  transition: transform 0.3s ease-in-out;
}

.na-aside-map.show {
  transform: translateX(0%);
}

.na-aside-content {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
  box-shadow: -4px 0 20px rgba(0, 0, 0, 0.15);
  border-radius: 12px 0 0 12px;
  user-select: none;
}

.na-aside-header {
  background-color: #006035;
  color: #fff;
  padding: 14px 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-shrink: 0;
}

.na-aside-title {
  margin: 0;
  font-weight: 700;
  font-size: 16px;
  color: #fff;
}

.na-aside-subtitle {
  margin: 0;
  font-weight: 400;
  font-size: 13px;
  color: rgba(255, 255, 255, 0.85);
}

.na-aside-close {
  color: #fff;
  padding: 4px 8px;
  font-size: 14px;
  line-height: 1;
}

.na-aside-close:hover {
  color: rgba(255, 255, 255, 0.7);
}

.na-aside-body {
  background-color: #EBEBEB;
  padding: 8px;
  overflow-y: auto;
  flex: 1;
  min-height: 0;
  scrollbar-width: thin;
  scrollbar-color: #006035 #FFFFFF;
}

.na-aside-body::-webkit-scrollbar {
  width: 8px;
}

.na-aside-body::-webkit-scrollbar-track {
  background: #FFFFFF;
  border-radius: 4px;
}

.na-aside-body::-webkit-scrollbar-thumb {
  background: #006035;
  border-radius: 4px;
}

.na-aside-body::-webkit-scrollbar-thumb:hover {
  background: #004d2a;
}

.na-aside-body::-webkit-scrollbar-button {
  display: none;
  width: 0;
  height: 0;
}

.na-aside-body::-webkit-scrollbar-button:start:decrement,
.na-aside-body::-webkit-scrollbar-button:end:increment {
  display: none;
}

.na-aside-body::-webkit-scrollbar-corner {
  display: none;
}

.na-aside-footer {
  background-color: #EBEBEB;
  padding: 8px 12px 12px;
  flex-shrink: 0;
}

/* Responsive */
@media (max-width: 700px) {
  .na-aside-header {
    padding-top: 60px !important;
  }
  .na-aside-map {
    width: 100vw;
  }
}
</style>
